import type { PaginatedRequestParams, PaginatedResponse } from '@/types/api';
import type { ManagerLaunchStatus } from '@/types/cycle-evaluation/ManagerLaunchStatus';

import { api } from '@/api/api';

export default {
    async getManagerLaunchStatus({
        pageNumber,
        pageSize,
        meta,
        signal,
    }: PaginatedRequestParams & { signal?: AbortSignal }): Promise<
        PaginatedResponse<ManagerLaunchStatus>
    > {
        const sentCycleId = meta?.sentCycleId;
        const isLaunched = meta?.isLaunched;

        if (!sentCycleId) {
            throw new Error('sentCycleId is required to fetch manager launch status');
        }

        if (isLaunched === undefined || isLaunched === null) {
            throw new Error('isLaunched is required to fetch manager launch status');
        }

        const response = await api.get<PaginatedResponse<ManagerLaunchStatus>>(
            `/cycleevaluation/${sentCycleId}/manager-launch-status/${isLaunched}`,
            {
                params: { pageNumber, pageSize },
                signal,
            },
        );

        return response.data;
    },

    async exportManagerLaunchStatus({
        meta,
        signal,
    }: { meta?: { sentCycleId: string }; signal?: AbortSignal } = {}): Promise<Blob> {
        const sentCycleId = meta?.sentCycleId;

        if (!sentCycleId) {
            throw new Error('sentCycleId is required to export manager launch status');
        }

        const response = await api.get(
            `/cycleevaluation/${sentCycleId}/manager-launch-status/export`,
            {
                responseType: 'blob',
                signal,
            },
        );

        return response.data;
    },
};
